export const productTree = {
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused ? '#3a90d7' : 'white',
        color: state.isFocused ? 'white' : 'rgba(103, 106, 108, 0.65)',
        '&:active': {
            backgroundColor: '#3a90d7'
        }
    }),

    container: (provided, state) => ({
        ...provided,
        paddingTop: 1,
        paddingBottom: 0,
    }),
    
    valueContainer: (provided, state) => ({
        ...provided,
        paddingTop: 0,
        paddingBottom: 0,
    }),
    
    control: (provided, state) => ({
        ...provided,
        minHeight: '24px',
        fontSize: '14px',
        minWidth: '120px',
        borderColor: state.isFocused || state.isSelected ? '#3a90d7' : 'rgb(238, 238, 238)',
        background: 'rgb(238, 238, 238)',
        boxShadow: 0,
        '&:hover': {
            border: '1px solid #3a90d7'
        }
    }),

    input: (provided, state) => ({
        ...provided,
        paddingTop: 0,
        paddingBottom: 0,
    }),
    
    multiValue: (provided, state) => {
        return state.data.isFixed
             ? { ...provided, marginTop: 0, marginBottom: 0 }
             : { ...provided, marginTop: 0, marginBottom: 0, backgroundColor: 'white' };
    },

    multiValueLabel: (provided, state) => {
        return state.data.isFixed
             ? { ...provided, paddingTop: 0, paddingBottom: 0, color: 'rgb(103, 106, 108)' }
             : { ...provided, paddingTop: 0, paddingBottom: 0, color: 'rgb(103, 106, 108)', paddingRight: 6 }
    },
    
    dropdownIndicator: (provided, state) => ({
        ...provided,
        color: 'rgb(204, 204, 204)',
        padding: 0,
        '&:hover': {
            color: 'rgb(103, 106, 108)',
        }
    }),

    clearIndicator: (provided, state) => ({
        ...provided,
        color: 'rgb(204, 204, 204)',
        padding: 0,
        '&:hover': {
            color: 'rgb(103, 106, 108)',
        }
    }),

    multiValueRemove: (provided, state) => {
        return state.data.isFixed || state.isDisabled
             ? { ...provided, display: 'none' }
             : { ...provided, 
                 '&:hover': {
                     backgroundColor: '#f8ac59',
                     color: 'rgb(103, 106, 108)',
                 }
             }
    },

}

export const multiSelect = {
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused ? '#3a90d7' : 'white',
        color: state.isFocused ? 'white' : 'rgba(103, 106, 108, 0.65)',
        '&:active': {
            backgroundColor: '#3a90d7'
        }
    }),

    control: (provided, state) => ({
        ...provided,
        fontSize: '14px',
        borderColor: state.isFocused || state.isSelected ? '#3a90d7' : 'rgb(229, 230, 231)',
        background: 'white',
        boxShadow: 0,
        '&:hover': {
            border: '1px solid #3a90d7'
        }
    }),

    multiValue: (provided, state) => {
        return state.data.isFixed ? { ...provided, backgroundColor: 'gray' } : provided;
    },

    multiValueLabel: (provided, state) => {
        return state.data.isFixed
             ? { ...provided, fontWeight: 'bold', color: 'white', paddingRight: 6 }
             : { ...provided, color: 'rgb(103, 106, 108)' }
    },
    
    dropdownIndicator: (provided, state) => ({
        ...provided,
        color: 'rgb(204, 204, 204)',
        '&:hover': {
            color: 'rgb(103, 106, 108)',
        }
    }),

    clearIndicator: (provided, state) => ({
        ...provided,
        color: 'rgb(204, 204, 204)',
        '&:hover': {
            color: 'rgb(103, 106, 108)',
        }
    }),

    multiValueRemove: (provided, state) => {
        return state.data.isFixed
             ? { ...provided, display: 'none' }
             : { ...provided, 
                 '&:hover': {
                     backgroundColor: '#f8ac59',
                     color: 'rgb(103, 106, 108)',
                 }
             }
    },

}

export const singleSelect = {
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused ? '#3a90d7' : 'white',
        color: state.isFocused ? 'white' : 'rgb(103, 106, 108)',
        opacity: state.isDisabled ? 0.5 : 1,
        '&:active': {
            backgroundColor: '#3a90d7'
        }
    }),

    control: (provided, state) => ({
        ...provided,
        fontSize: '14px',
        borderColor: state.isFocused || state.isSelected ? '#3a90d7' : 'rgb(229, 230, 231)',
        background: state.isDisabled ? 'var(--bs-secondary-bg)' : 'white',
        boxShadow: 0,
        '&:hover': {
            border: '1px solid #3a90d7'
        }
    }),

    dropdownIndicator: (provided, state) => ({
        ...provided,
        color: 'rgb(204, 204, 204)',
        '&:hover': {
            color: 'rgb(103, 106, 108)',
        }
    }),

    clearIndicator: (provided, state) => ({
        ...provided,
        color: 'rgb(204, 204, 204)',
        '&:hover': {
            color: 'rgb(103, 106, 108)',
        }
    }),

    singleValue: (provided, state) => ({
        ...provided,
        color: 'rgb(103, 106, 108)',
    }),
}
